import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import api from "../../services/api";
import chevronDown from "../../img/icon/down.svg";
import "./style.css"

// Contexto Select modificado para aceitar três argumentos (value, name, color)
const SelectContext = createContext((value: any, name: any, color: any) => { });

export const Options = ({ value, name, selected, color }: any) => {
  const selectContext: any = useContext(SelectContext);
  const [isSelected, setIsSelected] = useState(selected);
  const hasBeenCalled = useRef(false); // Adicionando useRef para rastrear a chamada inicial

  useEffect(() => {
    // Atualiza o estado isSelected sempre que o prop selected mudar
    setIsSelected(selected);
  }, [selected]);

  useEffect(() => {
    // Garantir que este código seja executado apenas uma vez
    if (selected && !hasBeenCalled.current) {
      selectContext(value, name, color);
      hasBeenCalled.current = true; // Marcar como chamado
    }
  }, [selected, selectContext, value, name, color]); // Dependências

  const handleClick = () => {
    selectContext(value, name, color);
    setIsSelected(true);
  };

  return (
    <div
      data-value={value}
      className={`option-dsg ${isSelected ? 'selected' : ''}`}
      style={{ color: color }} // Aplicando a cor via style
      onClick={handleClick}
    >
      {name}
    </div>
  );
};


export const Select = ({ children, width, onSelect, className, id, selectedValue }: any) => {
  const [selectedOption, setSelectedOption] = useState({ value: '', name: 'Selecione', color: '' });
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedValue) {
      setSelectedOption(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    const mainOption: any = selectRef.current?.querySelector('.option-dsg');
    if (mainOption) {
      mainOption.innerHTML = selectedOption.name;
      mainOption.setAttribute('data-value', selectedOption.value);
      mainOption.style.color = selectedOption.color; // Aplicando a cor
    }
  }, [selectedOption]);

  useEffect(() => {
    const select = selectRef.current;
    if (select) {
      let selects = select.querySelectorAll('.select-dsg');
      selects.forEach((selectElement) => {
        let originalHeight = (selectElement as HTMLElement).offsetHeight;
        let mainOption: any = selectElement.querySelector('.option-dsg');
        let selectedOptionElement: any = selectElement.querySelector('.option-dsg.selected');
        if (selectedOptionElement && mainOption) {
          mainOption.innerHTML = selectedOptionElement.innerHTML;
          mainOption.setAttribute('data-value', selectedOptionElement.getAttribute('data-value') || '');
          mainOption.style.color = selectedOptionElement.style.color; // Aplicando a cor
        }

        selectElement.addEventListener('click', (event) => {
          if ((selectElement as HTMLElement).offsetHeight > originalHeight) {
            (selectElement as HTMLElement).style.height = `${originalHeight}px`;
            if (event.target && (event.target as Element).classList.contains('option-dsg')) {
              if (selectedOptionElement) {
                selectedOptionElement.classList.remove('selected');
              }
              (event.target as Element).classList.add('selected');
              selectedOptionElement = event.target as Element;
              if (mainOption) {
                mainOption.innerHTML = selectedOptionElement.innerHTML;
                mainOption.setAttribute('data-value', selectedOptionElement.getAttribute('data-value') || '');
                mainOption.style.color = selectedOptionElement.style.color; // Aplicando a cor
              }
            }
          } else {
            let optionsCount = (selectElement as HTMLElement).querySelectorAll('.option-dsg').length;
            let optionHeight = ((selectElement as HTMLElement).querySelector('.option-dsg') as HTMLElement)?.offsetHeight || 0;
            (selectElement as HTMLElement).style.height = `${optionsCount * optionHeight}px`;
          }
        });
      });
    }
  }, []);
  const handleSelect = (value: any, name: any, color: any) => {
    setSelectedOption({ value, name, color });
    if (onSelect) {
      onSelect(value);
    }
  };

  return (
    <SelectContext.Provider value={handleSelect}>
      <div className={'select-dsg-content ' + className} ref={selectRef}>
        <div className={`select-dsg ${className}`} id={id} style={{ maxWidth: width }}>
          <div className="select-dsg-ico">
            <img src={chevronDown} alt="down" />
          </div>
          <Options
            value={selectedOption.value}
            name={selectedOption.name}
            color={selectedOption.color}
          />
          <div className='options-content'>
            {children}
          </div>
        </div>
      </div>
    </SelectContext.Provider>
  );
}
